import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

interface LanguageSwitcherProps {
  className?: string;
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ className = '' }) => {
  const { currentLanguage, switchLanguage, t } = useLanguage();

  const handleLanguageChange = (newLanguage: 'en' | 'es'): void => {
    if (newLanguage !== currentLanguage) {
      switchLanguage(newLanguage);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent, language: 'en' | 'es'): void => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleLanguageChange(language);
    }
  };

  const btn =
    'relative z-10 flex flex-1 items-center justify-center rounded-full py-0.5 font-jakarta text-[10px] font-semibold uppercase tracking-[0.12em] transition-colors duration-150 focus:outline-none focus-visible:ring-1 focus-visible:ring-chisme-primary/35';

  return (
    <div className={`inline-flex items-center ${className}`} role="radiogroup" aria-label="Language selection">
      <div className="relative flex h-7 w-[3.75rem] shrink-0 items-stretch rounded-full border border-[rgba(74,33,71,0.1)] bg-[rgba(252,247,250,0.9)] p-[3px]">
        <div
          className="pointer-events-none absolute top-1/2 h-[calc(100%-6px)] w-[calc(50%-3px)] -translate-y-1/2 rounded-full bg-white shadow-[0px_1px_2px_rgba(74,33,71,0.06)] ring-1 ring-[rgba(74,33,71,0.05)] transition-[left] duration-200 ease-out"
          style={{ left: currentLanguage === 'es' ? 'calc(50% + 1.5px)' : '3px' }}
          aria-hidden
        />

        <button
          type="button"
          onClick={() => handleLanguageChange('en')}
          onKeyDown={(e) => handleKeyDown(e, 'en')}
          className={`${btn} ${
            currentLanguage === 'en' ? 'text-chisme-primary' : 'text-[#5a3158]/45 hover:text-[#5a3158]/75'
          }`}
          aria-checked={currentLanguage === 'en'}
          aria-label={t('languageSwitcher.switchToEnglish')}
          role="radio"
          tabIndex={0}
        >
          {t('languageSwitcher.en')}
        </button>

        <button
          type="button"
          onClick={() => handleLanguageChange('es')}
          onKeyDown={(e) => handleKeyDown(e, 'es')}
          className={`${btn} ${
            currentLanguage === 'es' ? 'text-chisme-primary' : 'text-[#5a3158]/45 hover:text-[#5a3158]/75'
          }`}
          aria-checked={currentLanguage === 'es'}
          aria-label={t('languageSwitcher.switchToSpanish')}
          role="radio"
          tabIndex={0}
        >
          {t('languageSwitcher.es')}
        </button>
      </div>
    </div>
  );
};

export default LanguageSwitcher;
